import * as React from "react";
import { Spinner } from "@chakra-ui/react"

function Suspense () {
    return(
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh'
        }}>
            <Spinner
                thickness="4px"
                speed="0.5s"
                emptyColor="gray.200"
                color="blue.500"
                size="xl"
            />
        </div>
    )
}

export default Suspense